<template>
  <v-container class="fragment-home">

    <v-card class="mx-auto">
      <v-card-title>
        <v-tooltip right>
          <template v-slot:activator="{ on }">
            <span v-on="on">最新公告 </span>
          </template>
          <span>今日公告、未讀公告</span>
        </v-tooltip>
      </v-card-title>

      <v-card-text>

        <v-simple-table>
          <template v-slot:default>
            <thead>
              <tr>
                <th class="text-left">標題</th>
              </tr>
            </thead>
            <tbody>
              <tr
                v-for="item in announcementList"
                :key="item.ID"
                @click="toAnnouncementPage(item)"
                class="row-link"
              >
                <td>
                  {{ item.Title }}
                  <v-chip
                    v-if="item.ReadedAt==null"
                    color="red ml-4"
                    small
                  >NEW</v-chip>
                </td>
              </tr>
            </tbody>
          </template>
        </v-simple-table>

      </v-card-text>
      <v-card-actions>
        <v-btn
          text
          color="accent-4"
        >
          ...更多
        </v-btn>
      </v-card-actions>
    </v-card>

    <v-card class="mx-auto mt-4">
      <v-card-title>
        今日待辦事項
      </v-card-title>
      <v-card-text>

        <!-- 主管以上 -->
        <v-simple-table v-if="myLevel >= 10">
          <template v-slot:default>
            <thead>
              <tr>
                <th class="text-left">項目</th>
              </tr>
            </thead>
            <tbody>
              <tr
                v-for="item in todoList"
                :key="`todo-item-${item.ID}`"
                @click="toTodoPage(item)"
                class="row-link"
              >
                <td>
                  {{ item.Event.Content }}，{{ item.Content }}
                  <v-chip
                    v-if="item.DoneAt"
                    color="blue ml-4"
                    small
                  >已完成</v-chip>
                  <v-chip
                    v-ielse
                    color="red ml-4"
                    small
                  >執行中</v-chip>
                </td>
              </tr>
            </tbody>
          </template>
        </v-simple-table>

        <!-- 員工 -->
        <v-simple-table v-else>
          <template v-slot:default>
            <thead>
              <tr>
                <th class="text-left">項目</th>
              </tr>
            </thead>
            <tbody>
              <tr
                v-for="item in workLogList"
                :key="item.ID"
                @click="toWorkLogPage(item)"
                class="row-link"
              >
                <td>
                  {{ item.Title }}
                  <v-chip
                    v-if="item.ReadedAt==null"
                    color="red ml-4"
                    small
                  >NEW</v-chip>
                  <v-chip
                    v-if="item.Status==='reviewing'"
                    color="green ml-4"
                    small
                  >審核中</v-chip>
                  <v-chip
                    v-if="item.Status==='completed'"
                    color="blue ml-4"
                    small
                  >已完成</v-chip>
                </td>
              </tr>
            </tbody>
          </template>
        </v-simple-table>

      </v-card-text>
      <v-card-actions>
        <v-btn
          text
          color="accent-4"
        >
          ...更多
        </v-btn>
      </v-card-actions>
    </v-card>

  </v-container>
</template>

<script>
import { mapGetters } from "vuex";
export default {
  components: {},
  data: () => ({
    isLoading: true
  }),
  computed: {
    announcementList() {
      return this.$store.state.announcement.list;
    },
    todoList() {
      return this.todoItems;
    },
    workLogList() {
      return this.$store.state.taskWorkingItem.list;
    },
    ...mapGetters(["myLevel", "todoItems"])
  },
  methods: {
    toAnnouncementPage(item) {
      this.$router.push({ name: "announcement-list", params: { id: item.ID } });
    },
    toTodoPage(item) {
      this.$router.push({ name: "todo-list", params: { id: item.ID } });
    },
    toWorkLogPage(item) {
      this.$router.push({ name: "work-log-list", params: { id: item.ID } });
    }
  },
  created() {
    Promise.all([
      this.$services.prepareDatas(this),
      // this.$services.prepareProjectDatas(this) // 20220501 發現 prepareDatas時就會prepareProductDatas
    ]).finally(() => {
      this.isLoading = false;
    });
  }
};
</script>

<style>
.v-application .fragment-home .row-link {
  cursor: pointer;
}
</style>